import BaseUseCase from "../../../base_use_case.js";

class SaveInvestmentUseCase extends BaseUseCase {

  execute(identifier, params) {
    const url = identifier ? `/api/v1/admin/projects/investments/${identifier}` : '/api/v1/admin/projects/investments/create_custom';

    return this.httpClient({
      ...this.requestConfig(),
      method: identifier ? "put" : "post",
      url: url,
      data: this.wrapParams(params, "investment"),
    });
  }
}

const instance = new SaveInvestmentUseCase();
export default instance;
